<template>
  <custom-drop-down
    fieldkey="id"
    fieldname="name"
    class="dropdown__extended"
    :placeholder="placeholder"
    :clearable="false"
    :options="options"
    v-model="modelValue"
    @input="onChangeHandler"
  />
</template>

<script>
import CustomDropDown from 'custom-drop-down';
export default {
  name: 'CustomDropAction',
  components: {
    CustomDropDown,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modelValue: this.value,
    };
  },
  methods: {
    onChangeHandler() {
      this.$emit('input', this.modelValue);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
.dropdown__extended ::v-deep {
  .custom-v-select {
    width: 120px !important;
  }
  .vs__dropdown-toggle {
    border: unset !important;
  }
  .vs__selected {
    color: map-get($colors, 'primary-4') !important;
    font-size: 16px !important;
  }
  .vs__open-indicator {
    path {
      fill: map-get($colors, 'primary-4') !important;
    }
  }

  .vs__search {
  }
}
</style>
